import { ContractChangeValidationListFragment, NationalContractLevelEnum, NationalContractReferenceLevelDto } from '../../../../types'
import { getUndefinedContractChangeValuesForGivenMonth } from './validationHelpers'

const getSortedNationalContractReferenceLevels = (nationalReferenceLevels: NationalContractReferenceLevelDto[]) => {
  const referenceLevels: NationalContractReferenceLevelDto[] = nationalReferenceLevels
    .filter((item: NationalContractReferenceLevelDto) => item.selectable)
    .sort((a: NationalContractReferenceLevelDto, b: NationalContractReferenceLevelDto) => a.displayOrder - b.displayOrder)

  return referenceLevels
}

export type NationalContractLevelChangeValidationType = {
  valid: boolean
  minimalValidValue?: NationalContractLevelEnum
}

export const nationalContractLevelChangeValidation = (
  date: Date,
  nationalContractLevel: NationalContractLevelEnum,
  nationalReferenceLevels: NationalContractReferenceLevelDto[],
  contractChangeValidationList: ContractChangeValidationListFragment,
): NationalContractLevelChangeValidationType => {
  const nationalContractLevelOrderedList: NationalContractLevelEnum[] = getSortedNationalContractReferenceLevels(
    nationalReferenceLevels,
  ).map((item) => item.level as NationalContractLevelEnum)

  const minimalValidValue: NationalContractLevelEnum = getUndefinedContractChangeValuesForGivenMonth(date, contractChangeValidationList)
    .nationalContractLevel!
  if (nationalContractLevelOrderedList.indexOf(nationalContractLevel) <= nationalContractLevelOrderedList.indexOf(minimalValidValue)) {
    return {
      valid: false,
      minimalValidValue: minimalValidValue,
    }
  }

  return { valid: true }
}
